// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import less from 'less'
Vue.use(less)
import Vant from 'vant';
Vue.use(Vant);
import request from "./api/request";
Vue.prototype.$http = request;
import clipboard from 'clipboard'
Vue.prototype.clipboard = clipboard
import '@/assets/css/style.css'
import '@/assets/css/reset.css'
import 'vant/lib/index.css'; 
import 'vant/lib/icon/local.css'; //引用字体css

import 'babel-polyfill'
import promise from 'es6-promise'
require('es6-promise').polyfill()
promise.polyfill()

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js